<script type="text/javascript">
  export default {
    props: ['type', 'pc', 'slug', 'website'],
    data() {
      return {
        default_content: {
          type: 'blog',
          title: 'Blog',
          active: 1,
          image: '',
          color: 'gray-100',
          opacity: '',
          pad_t: '2',
          pad_r: '0',
          pad_b: '2',
          pad_l: '0',
          icon: '',
          icon_color: 'revinre',
          h2: '',
          h2_color: '',
          h2_desc: '',
          h2_desc_color: '',
          pre_btn: [],

          main_per_row: 2,
          main_bg_color: 'white',
          main_cat_color: 'revinre',
          main_title_color: 'black',
          main_btn_color: 'revinre',
          main_btn_pre_icon: '',
          main_btn_text: 'Read More',
          main_btn_post_icon: 'ri:arrow-right-line',
          main_sub_text_color: 'muted',

          cat_active: 1,
          cat_icon: 'ri:price-tag-3-line',
          cat_top_bg_color: 'dark',
          cat_top_text_color: 'white',
          cat_bg_color: 'white',
          cat_text_color: '',

          lat_active: 1,
          lat_icon: 'ri:newspaper-line',
          lat_top_bg_color: 'dark',
          lat_top_text_color: 'white',
          lat_bg_color: 'white',
          lat_text_color: 'black',
          lat_sub_text_color: 'muted',

          post_btn: [],
        },

        blog_url: '/',

        loading: true,
        results: [],
        pagination: {},
        filters: {
          paginate: 6,
          page: 1,
          total: 0,
          wheres: {
            slug: '',
          },
          category: '',
        },
      }
    },
    watch: {
      'filters.paginate': { handler: function(n, o) { this.pagination.current_page = 1; this.fetchData(); }},
    },
    created() {
      if(this.pc && this.pc.init == 'Yes') { for(var i in this.default_content) { this.pc[i] = this.default_content[i]; } this.pc.init = ''; }
      if(!this.pc.pre_btn) { this.pc.pre_btn = []; this.$forceUpdate(); }
      if(!this.pc.post_btn) { this.pc.post_btn = []; this.$forceUpdate(); }

      if(this.slug && this.slug.slug_dynamic) {
        this.blog_url = this.slug.slug_dynamic.replace('/:id','');
      } else if(this.slug && this.slug.slug) {
        this.blog_url = this.slug.slug;
      } else {
        this.blog_url = '/';
      }
      

      if(this.type != 'editor') {
        if(this.slug && this.slug.slug_id) {
          this.filters.category = '';
          this.filters.wheres.slug = '/'+this.slug.slug_id;
          console.log(this.filters);
          this.fetchData();
        } else if(this.slug && this.slug.slug_query && this.slug.slug_query.category) {
          this.filters.category = this.slug.slug_query.category;
          this.filters.wheres.slug = '';
          this.fetchData();
        } else {
          this.filters.category = '';
          this.filters.wheres.slug = '';
          this.fetchData();
        }
      }
    },
    methods: {
      fetchData() {
        this.loading = true;
        this.filters.page = this.pagination.current_page;
        this.$http.get((this.isAdmin ? '/api' : '')+'/blogs/fetch', {params: this.filters}).then(res => {
          // console.log(res);
          for(var i in res.data.data) {
            res.data.data[i].height = 200;
          }
          this.results = res.data.data;
          this.pagination = res.data;
          this.filters.total = res.data.total;
          this.loading = false;
        }).catch(res => {
          this.loading = false;
          // this.$noty.warning("There was an error loading the required data. Please try again and contact support if the problem persists.");
        });
      },
      toggleShow(test) {
        if(test.height == 200) { test.height = 2000; } else { test.height = 200; }
      }
    }
  }
</script>

<template>
  <section>

    <div v-if="type == 'editor'">
      <div class="p-3">
        <div class="row">
          <div class="col-sm-4">
            <w-field SimpleDataType="String List, Single" v-model="pc.active" Title="Active :" :Options="[{name:'Yes',value:1},{name:'No',value:0}]" v-tippy content="Display this section on the live website?"></w-field>
          </div>
        </div>
        <h6 class="section-header mt-3"><Icon icon="ri:book-2-line"></Icon> Section background and padding :</h6>
        <div class="row">
          <div class="col-sm-4">
            <w-field SimpleDataType="String" v-model="pc.image" Title="Background image URL :"></w-field>
          </div>
          <div class="col-sm-4">
            <w-field SimpleDataType="String List, Single" Title="Background color :" :Options="theme_colors" v-model="pc.color"></w-field>
          </div>
          <div class="col-sm-4">
            <w-field SimpleDataType="Number" v-model="pc.opacity" Min="0" Max="10" Title="Background color opacity :" v-tippy content="Background color transparency (0 through 10)"></w-field>
          </div>
          <div class="col-sm-3">
            <w-field SimpleDataType="Number" v-model="pc.pad_t" Min="0" Max="20" Title="Top padding :" v-tippy content="Padding for the top of the section (0 through 20)"></w-field>
          </div>
          <div class="col-sm-3">
            <w-field SimpleDataType="Number" v-model="pc.pad_r" Min="0" Max="20" Title="Right padding :" v-tippy content="Padding for the right of the section (0 through 20)"></w-field>
          </div>
          <div class="col-sm-3">
            <w-field SimpleDataType="Number" v-model="pc.pad_b" Min="0" Max="20" Title="Bottom padding :" v-tippy content="Padding for the bottom of the section (0 through 20)"></w-field>
          </div>
          <div class="col-sm-3">
            <w-field SimpleDataType="Number" v-model="pc.pad_l" Min="0" Max="20" Title="Left padding :" v-tippy content="Padding for the left of the section (0 through 20)"></w-field>
          </div>
        </div>
        <h6 class="section-header mt-3"><Icon icon="ri:book-2-line"></Icon> Section H2 title :</h6>
        <div class="row">
          <div class="col-sm-6">
            <w-field SimpleDataType="String" v-model="pc.icon" Title="Section icon :" v-tippy content="Section icon"></w-field>
          </div>
          <div class="col-sm-6">
            <w-field SimpleDataType="String List, Single" v-model="pc.icon_color" Title="Section icon color : " :Options="theme_colors"></w-field>
          </div>
          <div class="col-sm-6">
            <w-field SimpleDataType="String" v-model="pc.h2" Title="H2 title :" v-tippy content="Section title"></w-field>
          </div>
          <div class="col-sm-6">
            <w-field SimpleDataType="String List, Single" v-model="pc.h2_color" Title="H2 title color : " :Options="theme_colors"></w-field>
          </div>
          <div class="col-sm-6">
            <w-field SimpleDataType="Textarea" v-model="pc.h2_desc" Title="H2 description :" v-tippy content="Section description appearing below the section title"></w-field>
          </div>
          <div class="col-sm-6">
            <w-field SimpleDataType="String List, Single" v-model="pc.h2_desc_color" Title="H2 description color : " :Options="theme_colors"></w-field>
          </div>
        </div>

        <h6 class="section-header mt-3"><Icon icon="ri:book-2-line"></Icon> Top buttons :</h6>
        <div class="form-group">
          <draggable handle=".handle" v-bind="{animation: 200}" v-model="pc.pre_btn">
            <transition-group tag="div">
              <div v-for="(btn, btn_i) in pc.pre_btn" :key="'f1'+btn_i">
                <div class="row m-0 align-items-end">
                  <div class="col-2 p-0">
                    <w-field SimpleDataType="String" v-model="btn.pre_icon" Title="Pre icon :"></w-field>
                  </div>
                  <div class="col-2 p-0">
                    <w-field SimpleDataType="String" v-model="btn.text" Title="Text :"></w-field>
                  </div>
                  <div class="col-2 p-0">
                    <w-field SimpleDataType="String" v-model="btn.post_icon" Title="Post icon :"></w-field>
                  </div>
                  <div class="col-2 p-0">
                    <w-field SimpleDataType="String List, Single" v-model="btn.color" Title="Color : " :Options="theme_colors"></w-field>
                  </div>
                  <div class="col p-0">
                    <w-field SimpleDataType="String" v-model="btn.url" Title="URL :"></w-field>
                  </div>
                  <div class="_w-40 pb-2">
                    <button class="btn btn-white" type="button" v-tippy content="Delete" @click="pc.pre_btn.splice(btn_i, 1); $forceUpdate()"><Icon icon="ri:delete-bin-line"></Icon></button>
                  </div>
                  <div class="_w-40 pb-2">
                    <button class="btn btn-white handle" type="button" v-tippy content="Drag to arrange"><Icon icon="ri:drag-move-2-fill"></Icon></button>
                  </div>
                </div>
              </div>
            </transition-group>
          </draggable>
          <button class="btn btn-sm btn-primary" type="button" @click="pc.pre_btn.push({color: '', pre_icon: '', text: '', post_icon: '', url: ''}); $forceUpdate()"><Icon icon="ri:add-line" height="18"></Icon> Add button</button>
        </div>

        <h6 class="section-header mt-3"><Icon icon="ri:book-2-line"></Icon> Blog List :</h6>
        <div class="row">
          <div class="col-sm-4">
            <w-field SimpleDataType="Number" v-model="pc.main_per_row" Min="1" Max="4" Title="Blogs per row :" v-tippy content="How many blog articles per row on the main blog page (1 through 4)"></w-field>
          </div>
          <div class="col-sm-4">
            <w-field SimpleDataType="String List, Single" Title="Background color :" :Options="theme_colors" v-model="pc.main_bg_color"></w-field>
          </div>
          <div class="col-sm-4">
            <w-field SimpleDataType="String List, Single" Title="Category text color :" :Options="theme_colors" v-model="pc.main_cat_color"></w-field>
          </div>
          <div class="col-sm-4">
            <w-field SimpleDataType="String List, Single" Title="Title text color :" :Options="theme_colors" v-model="pc.main_title_color"></w-field>
          </div>
          <div class="col-sm-4">
            <w-field SimpleDataType="String List, Single" v-model="pc.main_sub_text_color" Title="Sub text color : " :Options="theme_colors"></w-field>
          </div>
          <div class="col-sm-4">
            <w-field SimpleDataType="String List, Single" v-model="pc.main_btn_color" Title="Button color : " :Options="theme_colors"></w-field>
          </div>
          <div class="col-sm-4">
            <w-field SimpleDataType="String" v-model="pc.main_btn_pre_icon" Title="Button pre icon :"></w-field>
          </div>
          <div class="col-sm-4">
            <w-field SimpleDataType="String" v-model="pc.main_btn_text" Title="Button text :"></w-field>
          </div>
          <div class="col-sm-4">
            <w-field SimpleDataType="String" v-model="pc.main_btn_post_icon" Title="Button post icon :"></w-field>
          </div>
        </div>
        
        <h6 class="section-header mt-3"><Icon icon="ri:book-2-line"></Icon> Blog categories :</h6>
        <div class="row">
          <div class="col-sm-4">
            <w-field SimpleDataType="String List, Single" v-model="pc.cat_active" Title="Active :" :Options="[{name:'Yes',value:1},{name:'No',value:0}]" v-tippy content="Display the blog categories selection field on the right of the blog?"></w-field>
          </div>
          <div class="col-sm-4">
            <w-field SimpleDataType="String" v-model="pc.cat_icon" Title="Categories icon :"></w-field>
          </div>
          <div class="col-sm-4">
            <w-field SimpleDataType="String List, Single" Title="Top background color :" :Options="theme_colors" v-model="pc.cat_top_bg_color"></w-field>
          </div>
          <div class="col-sm-4">
            <w-field SimpleDataType="String List, Single" Title="Top text color :" :Options="theme_colors" v-model="pc.cat_top_text_color"></w-field>
          </div>
          <div class="col-sm-4">
            <w-field SimpleDataType="String List, Single" Title="Bottom background color :" :Options="theme_colors" v-model="pc.cat_bg_color"></w-field>
          </div>
          <div class="col-sm-4">
            <w-field SimpleDataType="String List, Single" Title="Bottom text color :" :Options="theme_colors" v-model="pc.cat_text_color"></w-field>
          </div>
        </div>
        
        <h6 class="section-header mt-3"><Icon icon="ri:book-2-line"></Icon> Blog latest :</h6>
        <div class="row">
          <div class="col-sm-4">
            <w-field SimpleDataType="String List, Single" v-model="pc.lat_active" Title="Active :" :Options="[{name:'Yes',value:1},{name:'No',value:0}]" v-tippy content="Display the blog categories selection field on the right of the blog?"></w-field>
          </div>
          <div class="col-sm-4">
            <w-field SimpleDataType="String" v-model="pc.lat_icon" Title="Categories icon :"></w-field>
          </div>
          <div class="col-sm-4">
            <w-field SimpleDataType="String List, Single" Title="Top background color :" :Options="theme_colors" v-model="pc.lat_top_bg_color"></w-field>
          </div>
          <div class="col-sm-4">
            <w-field SimpleDataType="String List, Single" Title="Top text color :" :Options="theme_colors" v-model="pc.lat_top_text_color"></w-field>
          </div>
          <div class="col-sm-4">
            <w-field SimpleDataType="String List, Single" Title="Bottom background color :" :Options="theme_colors" v-model="pc.lat_bg_color"></w-field>
          </div>
          <div class="col-sm-4">
            <w-field SimpleDataType="String List, Single" Title="Bottom text color :" :Options="theme_colors" v-model="pc.lat_text_color"></w-field>
          </div>
          <div class="col-sm-4">
            <w-field SimpleDataType="String List, Single" Title="Bottom sub text color :" :Options="theme_colors" v-model="pc.lat_sub_text_color"></w-field>
          </div>
        </div>

        <h6 class="section-header mt-3"><Icon icon="ri:book-2-line"></Icon> Bottom buttons :</h6>
        <div class="form-group">
          <draggable handle=".handle" v-bind="{animation: 200}" v-model="pc.post_btn">
            <transition-group tag="div">
              <div v-for="(btn, btn_i) in pc.post_btn" :key="'f2'+btn_i">
                <div class="row m-0 align-items-end">
                  <div class="col-2 p-0">
                    <w-field SimpleDataType="String" v-model="btn.pre_icon" Title="Pre icon :"></w-field>
                  </div>
                  <div class="col-2 p-0">
                    <w-field SimpleDataType="String" v-model="btn.text" Title="Text :"></w-field>
                  </div>
                  <div class="col-2 p-0">
                    <w-field SimpleDataType="String" v-model="btn.post_icon" Title="Post icon :"></w-field>
                  </div>
                  <div class="col-2 p-0">
                    <w-field SimpleDataType="String List, Single" v-model="btn.color" Title="Color : " :Options="theme_colors"></w-field>
                  </div>
                  <div class="col p-0">
                    <w-field SimpleDataType="String" v-model="btn.url" Title="URL :"></w-field>
                  </div>
                  <div class="_w-40 pb-2">
                    <button class="btn btn-white" type="button" v-tippy content="Delete" @click="pc.post_btn.splice(btn_i, 1); $forceUpdate()"><Icon icon="ri:delete-bin-line"></Icon></button>
                  </div>
                  <div class="_w-40 pb-2">
                    <button class="btn btn-white handle" type="button" v-tippy content="Drag to arrange"><Icon icon="ri:drag-move-2-fill"></Icon></button>
                  </div>
                </div>
              </div>
            </transition-group>
          </draggable>
          <button class="btn btn-sm btn-primary" type="button" @click="pc.post_btn.push({color: '', pre_icon: '', text: '', post_icon: '', url: ''}); $forceUpdate()"><Icon icon="ri:add-line" height="18"></Icon> Add button</button>
        </div>

      </div>
    </div>

    <div v-else class="container-fluid">
      <div class="position-absolute _pos-l-0 _pos-t-0 _pos-r-0 _pos-b-0 _z-n1 _bg-repeat-none _bg-size-cover _bg-position-center" :style="'background-image: url('+(pc['image'] ? formatImage(pc['image']) : '')+')'"></div>
      <div class="position-absolute _pos-l-0 _pos-t-0 _pos-r-0 _pos-b-0 _z-n1" :class="'bg-'+pc['color']+' _o-'+pc['opacity']"></div>
      <div class="container-fluid m_py-35" :class="'pt-'+pc['pad_t']+' pr-'+pc['pad_r']+' pb-'+pc['pad_b']+' pl-'+pc['pad_l']">

        <div class="text-center _w-m-900 mx-auto mb-5">
          <Icon v-if="pc['icon']" :icon="pc['icon']" height="45" class="mb-2" :class="'text-'+pc['icon_color']"></Icon>
          <h2 v-if="pc['h2']" class="mb-3" :class="'text-'+pc['h2_color']" data-aos="fade-zoom-in">{{pc['h2']}}</h2>
          <p v-if="pc['h2_desc']" :class="'text-'+pc['h2_desc_color']" data-aos="fade-zoom-in">{{pc['h2_desc']}}</p>
        </div>

        <div v-if="pc['pre_btn'] && pc['pre_btn'].length" class="text-center mb-5">
          <a v-for="(btn, btn_i) in pc['pre_btn']" :key="btn_i" v-if="btn['text'] || btn['pre_icon'] || btn['post_icon']" class="btn btn-lg mb-3 mx-3" :class="'btn-'+btn['color']" :href="btn['url']" target="_blank">
            <Icon v-if="btn['pre_icon']" :icon="btn['pre_icon']" height="20"></Icon>
            <span v-if="btn['pre_icon'] && btn['text']" class="border-left mx-3"></span>
            {{ btn['text'] }}
            <span v-if="btn['post_icon'] && btn['text']" class="border-left mx-3"></span>
            <Icon v-if="btn['post_icon']" :icon="btn['post_icon']" height="20"></Icon>
          </a>
        </div>

        <div v-if="loading && !results.length" class="row">
          <div :class="'col-sm-'+(pc['cat_active'] || pc['lat_active'] ? 9 : 12)">
            <div class="row">
              <div v-for="c_i in 4" :key="c_i" :class="'col-sm-'+(pc['main_per_row'] == 1 ? 12 : (pc['main_per_row'] == 2 ? 6 : (pc['main_per_row'] == 3 ? 4 : (pc['main_per_row'] == 4 ? 3 : 4))))">
                <article class="card overflow-hidden mb-4" data-aos="fade-zoom-in" :class="'bg-'+pc['main_bg_color']">
                  <div class="_p-t-65p position-relative overflow-hidden">
                    <div class="ph position-absolute _pos-l-0 _pos-t-0 _pos-r-0 _pos-b-0"></div>
                  </div>
                  <div class="p-3 mx-3 rounded _m-t-n-15 _z-100" :class="'bg-'+pc['main_bg_color']">
                    <p class="text-center mb-1" :class="'text-'+pc['main_cat_color']"><div class="ph mb-2" style="height: 20px;"></div></p>
                    <h1 class="h5 text-center" :class="'text-'+pc['main_title_color']"><div class="ph mb-2" style="height: 20px;"></div></h1>
                    <hr class="my-3">
                    <div class="_h-m-150 overflow-hidden">
                      <div class="ph mb-2" style="height: 20px;"></div>
                      <div class="ph mb-2" style="height: 20px;"></div>
                      <div class="ph mb-2" style="height: 20px;"></div>
                      <div class="ph mb-2" style="height: 20px;"></div>
                      <div class="ph mb-2" style="height: 20px;"></div>
                    </div>
                    <hr class="mt-0 mb-3">
                    <div class="font-italic small" :class="'text-'+pc['main_sub_text_color']">
                      <div class="ph mb-2" style="height: 20px;"></div>
                    </div>
                  </div>
                </article>
              </div>
            </div>
          </div>
          <div v-if="pc['cat_active'] || pc['lat_active']" class="col-sm-3">
            <div v-if="pc['cat_active']">
              <ul class="nav flex-column rounded" :class="'bg-'+pc['cat_top_bg_color']+' text-'+pc['cat_top_text_color']">
                <li class="nav-item p-3 m-0 rounded-top"><Icon class="mr-2" :icon="pc['cat_icon']" /> Categories</li>
              </ul>
              <div class="_h-m-500 overflowy-auto mb-4">
                <ul class="nav flex-column rounded" :class="'bg-'+pc['cat_bg_color']">
                  <li v-for="c_i in 4" :key="c_i" class="nav-item">
                    <div class="nav-link py-2 border-top border-light" :class="'text-'+pc['cat_text_color']"><div class="ph" style="height: 20px;"></div></div>
                  </li>
                </ul>
              </div>
            </div>
            <div v-if="pc['lat_active']">
              <ul class="nav flex-column rounded" :class="'bg-'+pc['lat_top_bg_color']+' text-'+pc['lat_top_text_color']">
                <li class="nav-item p-3 m-0 rounded-top"><Icon class="mr-2" :icon="pc['lat_icon']" /> Latest posts</li>
              </ul>
              <div class="_h-m-500 overflowy-auto mb-4">
                <ul class="nav flex-column rounded" :class="'bg-'+pc['lat_bg_color']">
                  <li v-for="c_i in 4" :key="c_i" class="nav-item">
                    <div class="nav-link p-2 border-top border-light" :class="'text-'+pc['lat_text_color']">
                      <div class="row m-0">
                        <div class="_w-70"><div class="ph rounded mr-2" style="height: 50px;"></div></div>
                        <div class="col pr-0">
                          <div class="ph mb-2" style="height: 20px;"></div>
                          <div class="ph mb-2" style="height: 20px;"></div>
                          <div class="ph" style="height: 20px;"></div>
                        </div>
                      </div>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>

        <div v-if="!loading" class="row">
          <div :class="'col-sm-'+(pc['cat_active'] || pc['lat_active'] ? 9 : 12)">

            <a v-if="!loading && !results.length" class="card d-block text-center p-4 mb-4" :class="'bg-'+pc['cat_bg_color']+' text-'+pc['cat_text_color']" data-aos="fade-zoom-in">
              No results found. This could by caused by search filters or website maintenance. Please check back later or contact us.
            </a>

            <a v-if="filters.category" :href="blog_url" class="card d-block text-center p-4 mb-4" :class="'bg-'+pc['cat_bg_color']+' text-'+pc['cat_text_color']" data-aos="fade-zoom-in" v-tippy content="Clear search filters">
              <Icon class="float-left mt-0" icon="ri:close-circle-line" height="25"></Icon> Browsing by category <strong>{{ filters.category }}</strong>
            </a>

            <a v-if="slug && slug.slug_id && results && results.length == 1" :href="blog_url" class="card d-block text-center p-4 mb-4" :class="'bg-'+pc['cat_bg_color']+' text-'+pc['cat_text_color']" data-aos="fade-zoom-in" v-tippy content="Return to Blog home">
              <Icon class="float-left mt-0" icon="ri:arrow-left-double-fill" height="25"></Icon> Return to Blog home
            </a>
          
            <div class="row">
              <div v-for="(blog, blog_i) in results" :key="blog_i" :class="'col-sm-'+(pc['main_per_row'] == 1 || (slug && slug.slug_id && results && results.length == 1) ? 12 : (pc['main_per_row'] == 2 ? 6 : (pc['main_per_row'] == 3 ? 4 : (pc['main_per_row'] == 4 ? 3 : 4))))">
                <article class="card overflow-hidden mb-4" data-aos="fade-zoom-in" :class="'bg-'+pc['main_bg_color']">
                  <div class="position-relative _p-t-65p">
                    <a :href="slug && slug.slug_id && results && results.length == 1 ? '#' : blog_url+blog['slug']" class="position-absolute _pos-l-0 _pos-t-0 _pos-r-0 _pos-b-0 _z-0">
                      <img v-if="blog['thumbnail']" :src="formatImage(blog['thumbnail'])" :alt="blog['title']" class="w-100 h-100 object-fit">
                      <img v-else src="/images/no-image.jpg" :alt="blog['title']" class="img-fluid w-100 mx-auto d-block">
                    </a>
                  </div>
                  <div class="p-3 mx-3 rounded _m-t-n-15 _z-100" :class="'bg-'+pc['main_bg_color']">
                    <p class="text-center mb-1" :class="'text-'+pc['main_cat_color']">
                      <span v-for="(zet, zet_i) in blog.categories" :key="zet_i">{{zet}}<span v-if="(zet_i + 1) < blog.categories.length">, </span></span>
                    </p>
                    <h1 class="h5 text-center" :class="'text-'+pc['main_title_color']">{{ blog['title'] }}</h1>
                    <hr class="my-3">
                    <div class="overflow-hidden" :class="slug && slug.slug_id && results && results.length == 1 ? '' : '_h-m-150'" v-html="blog['content']"></div>
                    <div v-if="!(slug && slug.slug_id && results && results.length == 1)" class="position-relative text-center py-3">
                      <a v-if="pc['main_btn_text'] || pc['main_btn_pre_icon'] || pc['main_btn_post_icon']" class="btn btn-block" :class="'btn-'+pc['main_btn_color']" :href="blog_url+blog['slug']">
                        <Icon v-if="pc['main_btn_pre_icon']" :icon="pc['main_btn_pre_icon']" height="20"></Icon>
                        <span v-if="pc['main_btn_pre_icon'] && pc['main_btn_text']" class="border-left mx-3"></span>
                        {{ pc['main_btn_text'] }}
                        <span v-if="pc['main_btn_post_icon'] && pc['main_btn_text']" class="border-left mx-3"></span>
                        <Icon v-if="pc['main_btn_post_icon']" :icon="pc['main_btn_post_icon']" height="20"></Icon>
                      </a>
                    </div>
                    <hr class="mb-3" :class="slug && slug.slug_id && results && results.length == 1 ? 'mt-3' : 'mt-0'">
                    <div class="font-italic small" :class="'text-'+pc['main_sub_text_color']">
                      By {{ blog['posted_by'] }}
                      On {{ moment(blog.posted_on).format('ll') }}
                    </div>
                  </div>
                </article>
              </div>
            </div>

            <div class="pt-4">
              <w-pagination  :pagination="pagination" @paginate="results=[]; fetchData()" :offset="3" :center="true"></w-pagination>
            </div>

          </div>
          <div v-if="pc['cat_active'] || pc['lat_active']" class="col-sm-3">
            <div v-if="pc['cat_active']">
              <ul class="nav flex-column rounded" :class="'bg-'+pc['cat_top_bg_color']+' text-'+pc['cat_top_text_color']">
                <li class="nav-item p-3 m-0 rounded-top"><Icon class="mr-2" :icon="pc['cat_icon']" /> Categories</li>
              </ul>
              <div class="_h-m-500 overflowy-auto mb-4">
                <ul class="nav flex-column rounded" :class="'bg-'+pc['cat_bg_color']">
                  <li v-if="website['blog_categories']" v-for="(cat, cat_i) in website['blog_categories']" :key="cat_i" class="nav-item">
                    <a :href="blog_url+'?category='+cat" class="nav-link py-2 border-top border-light" :class="'text-'+pc['cat_text_color']"><Icon class="mr-2" :icon="pc['cat_icon']" /> {{ cat }}</a>
                  </li>
                </ul>
              </div>
            </div>
            <div v-if="pc['lat_active']">
              <ul class="nav flex-column rounded" :class="'bg-'+pc['lat_top_bg_color']+' text-'+pc['lat_top_text_color']">
                <li class="nav-item p-3 m-0 rounded-top"><Icon class="mr-2" :icon="pc['lat_icon']" /> Latest posts</li>
              </ul>
              <div class="_h-m-500 overflowy-auto mb-4">
                <ul class="nav flex-column rounded" :class="'bg-'+pc['lat_bg_color']">
                  <li v-for="(blog, blog_i) in results" :key="blog_i" class="nav-item">
                    <a :href="blog_url+blog['slug']" class="nav-link p-2 border-top border-light">
                      <div class="row m-0">
                        <div class="_w-70">
                          <img v-if="blog['thumbnail']" :src="formatImage(blog['thumbnail'])" :alt="blog['title']" class="img-fluid w-100 rounded mr-2">
                          <img v-else src="/images/no-image.jpg" :alt="blog['title']" class="img-fluid w-100 rounded mr-2">
                        </div>
                        <div class="col pr-0">
                          <h2 class="h6" :class="'text-'+pc['lat_text_color']">{{ blog['title'] }}</h2>
                          <p class="m-0 small" :class="'text-'+pc['lat_sub_text_color']">By {{ blog['posted_by'] }} On {{ moment(blog.posted_on).format('ll') }}</p>
                        </div>
                      </div>
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>

        <div v-if="pc['post_btn'] && pc['post_btn'].length" class="text-center">
          <a v-for="(btn, btn_i) in pc['post_btn']" :key="btn_i" v-if="btn['text'] || btn['pre_icon'] || btn['post_icon']" class="btn btn-lg mb-3 mx-3" :class="'btn-'+btn['color']" :href="btn['url']" target="_blank">
            <Icon v-if="btn['pre_icon']" :icon="btn['pre_icon']" height="20"></Icon>
            <span v-if="btn['pre_icon'] && btn['text']" class="border-left mx-3"></span>
            {{ btn['text'] }}
            <span v-if="btn['post_icon'] && btn['text']" class="border-left mx-3"></span>
            <Icon v-if="btn['post_icon']" :icon="btn['post_icon']" height="20"></Icon>
          </a>
        </div>

      </div>
    </div>
  </section>

</template>
